import { Modal } from 'antd';
import cn from 'classnames';
import classes from './styles.module.scss';

export const useDialog = () => {
  const [modal, context] = Modal.useModal();

  const showDialog = (type, { className, ...options }) => {
    const defaultTitles = {
      confirm: 'Are you sure?',
      warning: 'Warning',
      error: 'Error',
      info: 'Information',
      success: 'Success',
    };
    const modalFn = modal[type];
    if (!modalFn) {
      console.warn(`Modal type "${type}" is not supported.`);
      return;
    }
    modalFn({
      title: defaultTitles[type],
      content: '',
      onOk: () => {},
      onCancel: () => {},
      okText: 'OK',
      cancelText: 'Cancel',
      className: cn(classes.customModal, className),
      centered: true,
      closable: true,
      width: 500,
      ...options,
    });
  };

  return {
    showDialog,
    context,
  };
};
